<template>
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">
            <span class="mdi mdi-magnify"></span> Search Vehicles &amp; Tests
        </h5>
        <p>Enter a registration, make or model to lookup vehicle data</p>
        <div class="input-group input-group-lg mt-3">
            <input type="text" class="form-control" placeholder="Enter search term" aria-label="Search Term" v-model="searchTerm" ref="tbSearch" @keydown.enter="search">
            <div class="input-group-append">
                <button class="btn btn-success" type="button" @click="search"><span class="fa fa-search"></span></button>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                searchTerm: ''
            }
        },
        mounted() {
            this.$refs.tbSearch.focus()
        }, 
        methods: {
            search() {
                if (!this.searchTerm) {
                    return
                }

                this.$router.push({
                    name: 'search-test-results', 
                    params: { searchTermProp: this.searchTerm }
                })
            }
        }
    }
</script>